import {formatCurrency, LocaleConfig} from 'platform/locale';

export function getCurrencyPreview(values: LocaleConfig): string | null {
  return formatCurrency(values, 6492153.976, 2, 'EUR');
}
